// Layout
const dashboardLayout = () => import('@/layouts/HospitalLayout/DashboardLayout/dashboardLayout.vue')

const books = () => import('./views/index')
/* const addProduct = () => import('./views/addProduct') */

// start Routes
export default [
  {
    path: '/hospital/books',
    component: dashboardLayout,
    children: [{
      path: '',
      name: 'hospitalBooks',
      meta: {
        name: 'hospitalBooks',
        parentName: 'marketplace',
        userType: '',
        permission: '',
        role: 'veterinary.clinic_owner'
      },
      component: books
    }]
  }
]
